import { render, staticRenderFns } from "./core_buttons.vue?vue&type=template&id=f3437142&scoped=true"
import script from "./core_buttons.vue?vue&type=script&lang=js"
export * from "./core_buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3437142",
  null
  
)

export default component.exports